const fromAnyToBool = any => !!any;

// noinspection JSUnusedGlobalSymbols
export default fromAnyToBool;
